module.exports = __webpack_public_path__ + "static/img/bg34.ed544459.png";